var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit_solid_primairy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_01",
    transform: "translate(-589.000000, -553.000000)",
    fill: "#00B550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(370.000000, 237.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tax-Details",
    transform: "translate(20.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit/Solid/Grey",
    transform: "translate(199.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit_solid_primairy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53071429,2.14571429 L1.33285714,10.3442857 L0.153571429,14.5564286 L4.36571429,13.3771429 L12.5778571,5.16428571 L9.53071429,2.14571429 L9.53071429,2.14571429 Z M4.16,12.8935714 L1.74357143,10.4771429 L2.24857143,9.97214286 L4.665,12.3885714 L4.16,12.8935714 L4.16,12.8935714 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6321429,1.07714286 C12.6785714,0.122857143 11.3971429,0.279285714 11.3971429,0.279285714 L10.0357143,1.64071429 L13.0828571,4.65857143 L14.4292857,3.31214286 C14.43,3.31214286 14.5814286,2.03357143 13.6321429,1.07714286 L13.6321429,1.07714286 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.af1dd18a259b26a9060c593931edcc73.svg";
export { ForwardRef as ReactComponent };